import { PoolButton } from '@synergy/components-next';
import { styled } from '@mui/material';

export const ChipButton = styled(PoolButton)(() => ({
    borderRadius: '50vh',
}));
